module.exports = __webpack_public_path__ + "img/lpfv-sp.9865e969.png";